import { profileEditionByType } from "views/Config/Rules/ProfMenuItem";

export const VIEW = "viewRulesMonitor";

export const POLI = {
  attr: "poli",
  type: "policy",
  cmdRespColIdx: 8,
  titleEdit: "Policy",
  header: "POLICY",
};

export const PROFS = [
  {
    attr: "if",
    cmdRespColIdx: 2,
    type: "interface",
    titleEdit: "Interface Profile",
    header: "INTERFACE",
  },
  {
    attr: "vlan",
    cmdRespColIdx: 3,
    type: "vlan",
    titleEdit: "VLAN Profile",
    header: "VLAN",
  },
  {
    attr: "subscriberGroup",
    cmdRespColIdx: 4,
    type: "subscriber-group",
    titleEdit: "Subscriber Group Profile",
    header: "SUB-GROUP",
  },
  {
    attr: "subscriberId",
    cmdRespColIdx: 5,
    type: "subscriber-id",
    titleEdit: "Subscriber ID Profile",
    header: "SUB-ID",
  },
  {
    attr: "acc",
    cmdRespColIdx: 6,
    type: "access",
    titleEdit: "Access Profile",
    header: "ACCESS",
  },
];

export const TYPE_PROFILE_SHORTCUTF_MAP = {
  ...profileEditionByType(PROFS),
  policy: function (poliName, viewName, tab) {
    globalNavigate("viewPolicyMonitorEdit", {
      returnView: viewName,
      policy: poliName,
      tab,
    });
  },
};
